<template>
  <div>
    <div class="d-flex align-center mb-8">
      <div>
        <img
          src="~@/v2/assets/images/download.png"
          class="doc-img"
        />
      </div>
      <div class="flex-grow-1 pl-4">
        <div class="font-weight-bold text-3xl">
          Congratulations on completing your will!
        </div>
      </div>
    </div>
    <div class="radius-4 overflow-hidden shadow-4">
      <v-list-item dense>
        <v-list-item-avatar
          color="bg-primary-10 radius-4"
          size="36"
        >
          <v-icon
            color="black"
            size="24"
            >mdi-file-document-outline</v-icon
          >
        </v-list-item-avatar>
        <v-list-item-content>
          <div class="font-weight-bold text-2xl">Your Will</div>
        </v-list-item-content>
        <v-list-item-action>
          <div class="text-center">
            <h2 class="text-2xl">${{ willPrice }}</h2>
          </div>
        </v-list-item-action>
      </v-list-item>
      <div class="divider" />
      <div class="pa-2">
        <div
          v-for="(item, index) in features"
          :key="index"
        >
          <v-list-item
            dense
            class="feature-item"
          >
            <v-list-item-avatar
              class="mr-4 my-2"
              size="24"
              color="bg-white"
            >
              <v-icon
                color="primary"
                size="16"
                >mdi-check-bold</v-icon
              >
            </v-list-item-avatar>
            <v-list-item-content class="py-0">
              <span class="">{{ item.label }}</span>
            </v-list-item-content>
          </v-list-item>
        </div>
        <v-list-item
          dense
          class="feature-item mb-2 mt-2"
        >
          <v-list-item-action class="pa-0 ma-0 mr-4">
            <v-chip
              color="primary"
              text-color="black"
              class="font-weight-bold"
              >BONUS</v-chip
            >
          </v-list-item-action>
          <v-list-item-content class="py-0">
            <span class="font-weight-bold"
              >Store information in your Digital Vault</span
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          dense
          class="feature-item mb-2"
        >
          <v-list-item-action class="pa-0 ma-0 mr-4">
            <v-chip
              color="primary"
              text-color="black"
              class="font-weight-bold"
              >BONUS</v-chip
            >
          </v-list-item-action>
          <v-list-item-content class="py-0">
            <span class="font-weight-bold">Make your Funeral Wishes known</span>
          </v-list-item-content>
        </v-list-item>
      </div>
      <div class="bg-grey-20 d-flex align-center px-4 py-1">
        <v-spacer />
        <v-btn
          text
          small
          color="info"
          @click="openCode = true"
          >Apply code</v-btn
        >
      </div>
    </div>
    <!--div class="shadow-4 radius-4 overflow-hidden mt-4">
      <div class="border-divider pa-2">
        <h4>Included with your Will:</h4>
      </div>
      <v-list-item>
        <v-list-item-avatar color="bg-primary-10 radius-4" size="36">
          <v-icon color="black" size="24">mdi-safe-square-outline</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <h3>Digital Vault</h3>
          <div class="opacity-60 text-sm">Save assets, messages and contacts in your account</div>
        </v-list-item-content>
      </v-list-item>

      <div class="divider" />
      <v-list-item>
        <v-list-item-avatar color="bg-primary-10 radius-4" size="36">
          <v-icon color="black" size="24">mdi-text</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <h3>Wishes</h3>
          <div class="opacity-60 text-sm">Share your wishes for after you are gone</div>
        </v-list-item-content>
      </v-list-item>
    </div-->
    <!-- div class="text-lg mb-2 font-weight-bold mt-6">Options <span class="text-sm font-weight-regular">(click to add)</span></div-->
    <div
      class="text-lg mb-4 mt-6 font-weight-bold"
      v-if="showOption.partner"
    >
      Would you like to purchase a Will for your partner?
    </div>
    <div
      class="checkout-option overflow-hidden mb-4"
      :class="{ selected: local.partner }"
      v-if="showOption.partner"
    >
      <v-list-item @click="local.partner = !local.partner">
        <v-list-item-avatar
          v-if="local.partner"
          left
          color="success"
          size="24"
        >
          <v-icon
            size="16"
            color="white"
            >mdi-check-bold</v-icon
          >
        </v-list-item-avatar>
        <v-list-item-avatar
          v-else
          left
          color="white"
          size="24"
          style="border: 2px solid #d6dce7 !important"
        >
        </v-list-item-avatar>
        <v-list-item-content>
          <h3>Add Partners Will</h3>
          <div class="text-sm opacity-70">Buy now to save $80</div>
        </v-list-item-content>
        <v-list-item-action>
          <h3>${{ partnerPrice }}</h3>
        </v-list-item-action>
      </v-list-item>
      <div class="divider" />
      <v-expand-transition>
        <div v-show="expand.partner">
          <div class="text-sm pa-4">
            After checkout we will send you a link to give to your partner so
            they can create their Willed account without needing to pay.
          </div>
        </div>
      </v-expand-transition>
      <v-btn
        tile
        block
        @click="expand.partner = !expand.partner"
        text
        class="bg-grey-20"
        ><span v-if="expand.partner">Close</span
        ><span v-else>More info</span></v-btn
      >
    </div>
    <div
      class="checkout-option overflow-hidden mb-4"
      :class="{ selected: local.subscription }"
      v-if="showOption.subscription"
    >
      <v-list-item @click="local.subscription = !local.subscription">
        <v-list-item-avatar
          v-if="local.subscription"
          left
          color="success"
          size="24"
        >
          <v-icon
            size="16"
            color="white"
            >mdi-check-bold</v-icon
          >
        </v-list-item-avatar>
        <v-list-item-avatar
          v-else
          left
          color="white"
          size="24"
          style="border: 2px solid #d6dce7 !important"
        >
        </v-list-item-avatar>
        <v-list-item-content>
          <h3>Unlimited updates after 1 year</h3>
          <div class="text-sm opacity-70">Highly recommended</div>
        </v-list-item-content>
        <v-list-item-action>
          <h3>${{ subscriptionPrice }}</h3>
          <div class="text-sm opacity-60 font-weight-medium">per year</div>
        </v-list-item-action>
      </v-list-item>
      <div class="divider" />
      <v-expand-transition>
        <div v-show="expand.subscription">
          <div class="text-sm pa-4">
            <p>
              Traditionally a lawyer would charge you hundreds of dollars to
              create a Will and then charge you the same amount again if you
              wanted to change it in the future. For $14 a year you can make as
              many changes to your Will, Vault and Wishes as you want.
            </p>
            <strong
              >The first payment will occur after 1 year. We will remind you
              before it is due and you can cancel any time from your
              account.</strong
            >
          </div>
        </div>
      </v-expand-transition>
      <v-btn
        tile
        block
        @click="expand.subscription = !expand.subscription"
        text
        class="bg-grey-20"
        ><span v-if="expand.subscription">Close</span
        ><span v-else>More info</span></v-btn
      >
    </div>
    <div class="text-center pb-4 pt-6">
      <v-btn
        v-bind="largeButton"
        :loading="loading"
        @click="goToCheckout()"
        ><template v-if="localFormatted.total === 0">Continue</template
        ><template v-else>Buy Now</template> (${{
          localFormatted.total
        }})</v-btn
      >
      <v-img
        src="@/v2/assets/images/stripe-badge.png"
        width="340"
        class="d-block mx-auto mt-6"
      ></v-img>
    </div>
    <drawer
      :open.sync="openCode"
      title="Apply Discount"
    >
      <div class="pa-4">
        <form-discount-code
          v-if="openCode"
          @next="openCode = false"
          @close="openCode = false"
        />
      </div>
    </drawer>
    <drawer
      :open.sync="openCheckout"
      title="Payment"
    >
      <payment-checkout
        v-if="openCheckout"
        v-bind="localFormatted"
      />
    </drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

import { functions } from "../../../plugins/firebase"
import PaymentCheckout from "../../components/checkout/PaymentCheckout"
import FormDiscountCode from "../../components/form/DiscountCode"
import Drawer from "../../components/wrapper/Drawer"

export default {
  name: "CheckoutPurchase",
  components: { PaymentCheckout, FormDiscountCode, Drawer },
  data: () => ({
    local: {
      partner: false,
      subscription: true,
    },
    expand: {
      partner: false,
      subscription: false,
    },
    showOption: {
      partner: true,
      subscription: false,
    },
    openCode: false,
    openCheckout: false,
    loading: false,
    features: [
      {
        label: "Your legally valid Will",
      },
      {
        label: "Unlimited changes for 1 year",
      },
      {
        label: "Download instantly",
      },
      {
        label: "Reviewed by our legal team on request",
      },
    ],
  }),
  mounted() {
    if (!this.$store.getters["account/user_partner"].optionItem?.partner) {
      this.local.partner = false
      this.showOption.partner = false
    }
  },
  methods: {
    async goToCheckout() {
      if (this.localFormatted.total > 0) {
        this.openCheckout = true
        return
      }

      this.loading = true

      await functions
        .httpsCallable("clientPurchaseProducts")({
          uid: this.$store.getters["account/auth_user"].uid,
          price: this.total,
          product: "will",
          plan: null,
          partner: false,
          promoCode: this.localFormatted.promoCode,
          prepaidCode: this.localFormatted.prepaidCode,
        })
        .then(async (resp) => {
          if (resp.data.status === "completed") {
            let query = {
              pt: "f",
              pd: 0,
              pn: "will",
            }
            if (this.localFormatted.promoCode) {
              query.pc = this.localFormatted.promoCode
            }
            if (this.localFormatted.prepaidCode) {
              query.pp = this.localFormatted.prepaidCode
            }

            await this.$router.push({ path: "/", query: query })
          }
        })
        .catch((err) => {
          this.$store.commit("app/SET_MESSAGE", {
            type: "error",
            text: err,
          })
          this.loading = false
        })
    },
  },
  computed: {
    ...mapGetters("app", [
      "pricing",
      "referrer_discount_price",
      "discount_code",
    ]),
    willPrice() {
      if (this.discount_code) {
        return this.discount_code.price
      }
      if (this.referrer_discount_price !== null) {
        return this.referrer_discount_price
      }

      return this.pricing.products.will.base
    },
    partnerPrice() {
      return this.pricing.products.will.additional
    },
    subscriptionPrice() {
      return this.pricing.subscriptions.plans[
        this.pricing.subscriptions.defaultPlan
      ].price
    },
    localFormatted() {
      let val = {
        total: this.willPrice,
        items: [
          {
            name: "Legal Will",
            // caption: this.local.subscription ? '+ unlimited updates after 1 year' : null,
            key: "will",
            price: this.willPrice,
          },
        ],
        includesPartner: this.local.partner,
        subscriptionPlan: this.local.subscription
          ? this.pricing.subscriptions.defaultPlan
          : null,
      }

      val.prepaidCode =
        this.discount_code?.type === "prepaid"
          ? this.discount_code.code.trim().toUpperCase()
          : null
      val.promoCode =
        this.discount_code?.type === "promocode"
          ? this.discount_code.code.trim().toUpperCase()
          : null

      if (val.includesPartner) {
        val.items.push({
          name: "Partners Will",
          key: "partner",
          price: this.partnerPrice,
        })
        val.total = val.total + this.partnerPrice
      }

      return val
    },
  },
}
</script>

<style lang="scss">
.feature-item {
  min-height: 0px;
}

.doc-img {
  height: 70px;
  width: auto;
}

.checkout-option {
  border-radius: 4px;
  border: 1px solid var(--grey);
  &.selected {
    border-color: #888;
  }
}
</style>
